var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nutritional-information__row"},[_c('div',{staticClass:"nutritional-information__cell"},[_vm._v("\n    "+_vm._s(_vm.value.toUpperCase())+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"nutritional-information__cell"},[_c('nutritional-info',{attrs:{"property":_vm.value,"value":_vm.nutritionalInfo[_vm.value]}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }